<script setup>
import { useSessionData } from '../composables/useSessionData'
import defaultSiteTheme from '../theme/defaultSiteTheme'
import getTintsAndShades from '../utils/color/getTintsAndShades'
import isWhite from '../utils/color/isWhite'
import isBright from '../utils/color/isBright'

const { currentProviderTheme } = useSessionData()
const theme = currentProviderTheme || defaultSiteTheme

const font = theme.font === 'Default' ? 'Hind' : theme.font
const colorAccent = theme.accent_color
const colorAccentContrast = theme.contrasting_accent_color
const colorUnderlayBackground = theme.underlay_background_color
const colorUnderlayText = theme.underlay_text_color
const colorNavBackground = theme.tab_background_color
const colorNavBackgroundHover = theme.tab_background_hover_color
const colorNavText = theme.tab_text_color

const fontImportIfNotHindOrRobotoSlab = ['Hind', 'Roboto Slab'].includes(font)
  ? ''
  : `@import url('https://fonts.googleapis.com/css2?family=${font.replace(' ', '+')}:wght@200;300;400;500;600;700&display=swap');`

const accentColorBase = `#${colorAccent}`
const tints = getTintsAndShades('tint', accentColorBase)
const shades = getTintsAndShades('shade', accentColorBase)
const buttonFillPrimaryFillRingWidth = isWhite(theme.accent_color) ? '1px' : '0px'
const colorAccentTextContrast = isWhite(theme.accent_color) ? 'var(--colors-secondary-300)' : `#${theme.accent_color}`
const checkboxCheckedBackground = isBright(theme.accent_color) ? theme.contrasting_accent_color : theme.accent_color

const themeStyle = `
${fontImportIfNotHindOrRobotoSlab}

:root {
  --theme-font: "${font}";
  --theme-color-accent: #${colorAccent};
  --theme-color-accent-contrast: #${colorAccentContrast};
  --theme-color-accent-tint-20: ${tints[0]};
  --theme-color-accent-tint-40: ${tints[1]};
  --theme-color-accent-tint-60: ${tints[2]};
  --theme-color-accent-tint-80: ${tints[3]};
  --theme-color-accent-shade-20: ${shades[0]};
  --theme-color-accent-shade-40: ${shades[1]};
  --theme-color-accent-shade-60: ${shades[2]};
  --theme-color-accent-shade-80: ${shades[3]};
  --theme-color-underlay-background: #${colorUnderlayBackground};
  --theme-color-underlay-text: #${colorUnderlayText};
  --theme-color-nav-background: #${colorNavBackground};
  --theme-color-nav-background-hover: #${colorNavBackgroundHover};
  --theme-color-nav-text: #${colorNavText};
  --theme-color-accent-text-contrast: ${colorAccentTextContrast};
  --theme-btn-fill-primary-ring-width: ${buttonFillPrimaryFillRingWidth};
  --theme-checkbox-checked-background: #${checkboxCheckedBackground};
}
`
</script>

<template>
  <component
    is="style"
    v-text="themeStyle"
  />
</template>
